import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const i18n = new VueI18n({
  fallbackLocale: 'en',
  locale: 'en',
  messages: {
    en: {
      Client: 'Member',
      Clients: 'Members',
      Professional: 'Trainer',
      Professionals: 'Trainers',
      client: 'member',
      professional: 'trainer'
    }
  }
})

export default i18n
